import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {IPaginatedResponse} from "../../request/IResponse";

export interface IMyApplicationsListItem {
    pk: number;
    property: null | number;
    offer: number;
    vendor: number;
}

export interface IMyApplicationsListResponse extends IPaginatedResponse {
    results: IMyApplicationsListItem[];
}

export const getMyApplicationsListUrl = (): string => {
    const query = {
        "i[]": ["application.offer", "application.property"],
        page_size: 1000
    };

    return appendQueryString(apiLink.application.sent({})(null), query);
};

export const fetchMyApplicationsList = (meta: IRPRequestMeta): Promise<IMyApplicationsListResponse> => {
    return getRequest(meta, getMyApplicationsListUrl());
};
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {IPaginatedResponse} from "../../request/IResponse";

export interface IMyApplicationsListItem {
    pk: number;
    property: null | number;
    offer: number;
    vendor: number;
}

export interface IMyApplicationsListResponse extends IPaginatedResponse {
    results: IMyApplicationsListItem[];
}

export const getMyApplicationsListUrl = (): string => {
    const query = {
        "i[]": ["application.offer", "application.property"],
        page_size: 1000
    };

    return appendQueryString(apiLink.application.sent({})(null), query);
};

export const fetchMyApplicationsList = (meta: IRPRequestMeta): Promise<IMyApplicationsListResponse> => {
    return getRequest(meta, getMyApplicationsListUrl());
};
